import { renderTopbar } from '../components/topbar.js';
import { renderCalendarHistory } from '../components/calendarHistory.js';
import { getStudentQuizHistory } from '../lib/quizScore.js';
import { friendlyError } from '../lib/friendlyError.js';

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// School owner: a read-only look at one linked student's quiz history
// (#/school/student/:email — reached from the "View scores" button on the
// Students panel in views/school.js). Server-side (functions/quizScores.js
// getStudentQuizHistory) verifies the caller owns the school AND that this
// email actually resolves to a student currently linked to it — being on
// the roster list alone isn't enough.
export function renderSchoolStudentScores(container, { email }) {
  container.innerHTML = '';
  container.appendChild(renderTopbar('/school'));

  const main = document.createElement('div');
  main.className = 'main-full';
  main.innerHTML = `<div class="empty-state">Loading student scores…</div>`;
  container.appendChild(main);

  getStudentQuizHistory(email)
    .then((attempts) => {
      main.innerHTML = `
        <p><a href="#/school">← Back to School</a></p>
        <h1 style="margin-bottom:4px;">🗓️ ${escapeHtml(email)}</h1>
        <p style="color:var(--text-dim);margin-top:0;">Quiz scores for this student, by date.</p>
        ${attempts.length === 0
          ? '<div class="empty-state"><div style="font-size:2.5rem;">📊</div><h3>No quiz scores yet</h3><p>This student hasn\'t completed a quiz yet.</p></div>'
          : '<div id="scores-calendar"></div>'}
      `;
      if (attempts.length > 0) {
        renderCalendarHistory(main.querySelector('#scores-calendar'), { attempts });
      }
    })
    .catch((err) => {
      main.innerHTML = `
        <p><a href="#/school">← Back to School</a></p>
        <div class="empty-state"><p>${friendlyError(err, 'Could not load this student\'s scores.')}</p></div>
      `;
    });

  return () => {};
}
